import { render } from "./ProjectLogHistoryTable.vue?vue&type=template&id=74611d12&scoped=true&ts=true"
import script from "./ProjectLogHistoryTable.vue?vue&type=script&lang=ts"
export * from "./ProjectLogHistoryTable.vue?vue&type=script&lang=ts"

import "./ProjectLogHistoryTable.vue?vue&type=style&index=0&id=74611d12&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74611d12"]])

export default __exports__